export default __webpack_public_path__ + "static/media/vincennes2.95821d21.jpg";